angular
  .module("myApp")
  .directive("expertsFilelist", () => {
    return {
      templateUrl: "directives/experts-filelist.html",
      controller: "ExpertsFilelistController",
      scope: {
        dto: "=",
        me: "=",
      },
    };
  })

  .controller("ExpertsFilelistController", ($scope, Codifiers) => {
    $scope.kla = Codifiers.kla;

    $scope.attachments = null;

    const refreshFiles = () => {
      const me = $scope.me;
      const dto = $scope.dto;

      $scope.attachments = [];

      if (!me) return;
      if (!dto) return;
      if (!dto?.pielikumi?.length) return;

      if (me.veids === "INITIAL") {
        $scope.attachments = dto.pielikumi.filter((p) => {
          if (!p.ir_redzams_ekspertam) return false;
          return true;
        });
      } else if (me.veids === "MIDTERM") {
        $scope.attachments = dto.pielikumi.filter((p) => {
          if (!p.ir_redzams_ekspertam) return false;
          if (p.pielikuma_veids.startsWith("VIDUSPOSMS")) return true;
          if (p.pielikuma_veids === "PROPOSAL") return true;
          // console.log('midterm skipping ' + p.pielikuma_veids)
          return false;
        });
      } else if (me.veids === "FINAL") {
        $scope.attachments = dto.pielikumi.filter((p) => {
          if (!p.ir_redzams_ekspertam) return false;
          if (p.pielikuma_veids.startsWith("GALAPOSMS")) return true;
          if (p.pielikuma_veids === "PROPOSAL") return true;
          // console.log('final skipping ' + p.pielikuma_veids)
          return false;
        });
      } else {
        // console.log(`Unfamiliar me.veids=${me.veids}`)
        return dto.pielikumi;
      }
    };

    $scope.$watch("dto", refreshFiles);
    $scope.$watch("me", refreshFiles);
  });
